The position title.

This field has a maximum length of 80 characters.
